import { PubSubType } from "@/const";
import {
  createInitialWorkspaceHistoryState,
  reconcileWorkspaceHistory,
  upsertPendingWorkspaceHistory,
  type WorkspaceHistoryState,
} from "@/domain/workspace-history";
import type { Payload, RootState } from "@/types/type";
import type { EffectsCommandMap } from "@umijs/max";
import PubSub from "pubsub-js";

export type { WorkspaceHistoryState } from "@/domain/workspace-history";

export default {
  state: createInitialWorkspaceHistoryState(),
  reducers: {
    upsertPending(
      state: WorkspaceHistoryState,
      { payload }: Payload,
    ): WorkspaceHistoryState {
      return upsertPendingWorkspaceHistory(state, payload);
    },
    reconcilePersisted(
      state: WorkspaceHistoryState,
      { payload }: Payload,
    ): WorkspaceHistoryState {
      return reconcileWorkspaceHistory(state, payload);
    },
  },
  effects: {
    *recordCreated(
      { payload }: Payload,
      { put, select }: EffectsCommandMap,
    ): Generator {
      const userId = String(
        (yield select((state: RootState) => state.userInfo.lbChatUserInfo?.id)) ||
          "",
      );
      yield put({
        type: "upsertPending",
        payload: { ...payload, userId },
      });

      // 旧版侧栏仍依赖广播刷新；新版工作区只消费本 model 的状态。
      PubSub.publish(PubSubType.RESET_LEFT_HISTORY, true);
    },
  },
};
